import React from 'react';
import useAuth from 'app/hooks/useAuth'
import Forbidden from 'app/views/sessions/Forbidden';

const RouteAccess = ({ children, keyId }) => {
  const { application } = useAuth();
  const allowedMenus = application?.map(menu => menu.id) || [];

  const allowedSubmenu = application?.flatMap(menu =>
    menu.children?.map(child => child.menu_id) || []
  ) || [];

  const allowedKeys = [...allowedMenus, ...allowedSubmenu];
  const hasAccess = allowedKeys?.includes(keyId);

  if (!hasAccess) return <Forbidden />;
  return children;
};

export default RouteAccess;
